import { GroupedPlayersData, PlayerWithRisk } from '../dashboard.type';

export type ListLayoutProps = {
  playersData: GroupedPlayersData;
  onPlayerClick: (player: PlayerWithRisk) => void;
};

export enum HoverKey {
  HighDown = 'highDown',
  HighUp = 'highUp',
  LowDown = 'lowDown',
  LowUp = 'lowUp',
}

export type HoverState = Record<HoverKey, boolean>;
